var _rect, _path, _path2, _path3, _path4, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 40,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.357 30.7471L24.7249 28.3319L23.9054 28.3122H19.9922L22.7117 10.4895C22.7202 10.4355 22.7476 10.3854 22.7876 10.3497C22.8278 10.3141 22.879 10.2946 22.9326 10.2946H29.5309C31.7216 10.2946 33.2333 10.7656 34.0225 11.6955C34.3925 12.1318 34.6282 12.5877 34.7423 13.0894C34.8619 13.6158 34.8638 14.2447 34.7472 15.0119L34.7387 15.0677V15.5593L35.1087 15.776C35.4203 15.9469 35.6679 16.1424 35.8579 16.3662C36.1743 16.7393 36.3791 17.2134 36.4656 17.7753C36.555 18.3533 36.5255 19.0413 36.3791 19.82C36.2102 20.7157 35.9373 21.4959 35.5686 22.1342C35.2297 22.7224 34.7978 23.2103 34.2849 23.5883C33.7953 23.9476 33.2136 24.2203 32.5559 24.3948C31.9185 24.5663 31.1918 24.6528 30.3947 24.6528H29.8813C29.5142 24.6528 29.1575 24.7895 28.8775 25.0345C28.5968 25.2846 28.4111 25.6263 28.3542 26L28.3154 26.2175L27.6653 30.4746L27.636 30.6308C27.6281 30.6803 27.6147 30.7049 27.595 30.7216C27.5775 30.7369 27.5522 30.7471 27.5276 30.7471H24.357",
    fill: "#28356A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4595 15.1245C35.44 15.2546 35.4173 15.3876 35.3921 15.5243C34.5219 20.142 31.5449 21.7373 27.7428 21.7373H25.8068C25.3418 21.7373 24.9499 22.0861 24.8776 22.5603L23.6057 30.899C23.5586 31.2104 23.7907 31.4909 24.0946 31.4909H27.5282C27.9347 31.4909 28.2801 31.1856 28.3441 30.7711L28.3778 30.5909L29.0243 26.3505L29.0659 26.118C29.1291 25.7021 29.4753 25.3966 29.8818 25.3966H30.3953C33.722 25.3966 36.3263 24.0007 37.0874 19.961C37.4052 18.2735 37.2407 16.8644 36.3994 15.8734C36.1448 15.5746 35.8289 15.3265 35.4595 15.1245",
    fill: "#298FC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5487 14.7494C34.4157 14.7093 34.2785 14.6731 34.1379 14.6403C33.9964 14.6083 33.8516 14.58 33.7024 14.5551C33.1804 14.468 32.6084 14.4266 31.9958 14.4266H26.8241C26.6966 14.4266 26.5756 14.4564 26.4675 14.5101C26.2288 14.6287 26.0517 14.8621 26.0088 15.1478L24.9085 22.3503L24.877 22.5603C24.9493 22.0862 25.3412 21.7373 25.8062 21.7373H27.7421C31.5442 21.7373 34.5213 20.1413 35.3914 15.5244C35.4174 15.3877 35.4393 15.2547 35.4588 15.1246C35.2387 15.0038 35.0003 14.9005 34.7436 14.8126C34.6801 14.7908 34.6147 14.7698 34.5487 14.7494",
    fill: "#22284F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0091 15.1478C26.052 14.8621 26.2292 14.6287 26.4678 14.5109C26.5767 14.457 26.6969 14.4272 26.8244 14.4272H31.9961C32.6087 14.4272 33.1807 14.4688 33.7027 14.556C33.8519 14.5806 33.9967 14.6091 34.1382 14.6411C34.2788 14.6737 34.416 14.7101 34.549 14.75C34.615 14.7704 34.6804 14.7916 34.7445 14.8126C35.0012 14.9005 35.2398 15.0046 35.4599 15.1246C35.7188 13.4181 35.4577 12.2563 34.5651 11.2042C33.5809 10.0458 31.8048 9.55005 29.5319 9.55005H22.9335C22.4692 9.55005 22.0732 9.89891 22.0014 10.3738L19.2531 28.3798C19.1989 28.736 19.4647 29.0574 19.8123 29.0574H23.8859L26.0091 15.1478",
    fill: "#28356A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    stroke: "#2F2B43",
    strokeOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.506d9b4abb818899fd0bd8d094cbffc6.svg";
export { ForwardRef as ReactComponent };